// extracted by mini-css-extract-plugin
module.exports = {"Tag":"DealTypeLabel_Tag___5amF"};